import { signOut, getAuth } from "firebase/auth";
import { useState, useEffect, useRef } from 'react';
import { Navigate, useNavigate } from "react-router-dom";
export function AdminMenu({userMail}:any) {
    const [responsiveMenu, setResponsiveMenu] = useState(false);
    let navigate = useNavigate();
    const onClickHandler = (e) => {
        setResponsiveMenu(!responsiveMenu);
    };
    const auth = getAuth()
    async function handleSignOut() {
        console.log(auth);
        try {
            await signOut(auth);
        } catch (error) {
            console.log(error)
        }
    }
    async function Naviageto(e, navlink) {
        e.preventDefault();
        navigate(navlink);
    }
    const getMenu=()=>
    {
        return(
<ul>
                                
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/manageevent') }} title="">Home</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/managetemplates') }} title="">Templates</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/managenews') }} title="">News</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/manageblogs') }} title="">Blogs</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/managegallery') }} title="">Gallery</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/manageaudienceexperience') }} title="">Audience Exp</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/managetestimonials') }} title="">Testimonials</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/weba/managemediacoverage') }} title="">Media Coverage</a></li>
                                   {/* <li><a href="#" onClick={(e) => { Naviageto(e, '/admin/managecoupons') }} title="">Coupons</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/admin/managespeakers') }} title="">Speakers</a></li>
                                    <li><a href="#" onClick={(e) => { Naviageto(e, '/admin/managesponsors') }} title="">Sponsors</a></li>
<li><a href="#" onClick={(e) => { Naviageto(e, '/admin/manageschedule') }} title="">Schedule</a></li>*/}
                                    <li></li>
                <li className="nav-item dropdown">
        <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i data-toggle="tooltip" title={`Logged in as ${userMail}`} className="fa fa-solid  fa-user"/>
        </a>
        <div className="dropdown-menu" aria-labelledby="navbarDropdown">
            <a className="dropdown-item" data-toggle="tooltip" title={`Logged in as ${userMail}`} >{`${userMail.split('@')[0]}`}</a>
          <div className="dropdown-divider"></div>
            <a className="dropdown-item" href="#" onClick={() => { handleSignOut() }} title="">Sign Out</a>
        </div>
      </li>
                     
            
                                </ul>
        );
    }
    return <>
        <header id="admin" className="fixed-admin">
            <div className="container">
                <div className="header-content">
                    
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6 col-10">
                            <div className="logo">
                                <div className="sec-title">

                                    <img src="../../../images/bb.png" />
                                </div>
                                {/*   <!--sec-title end-->  */}
                            </div> {/*  <!--logo end-->  */}
                        </div>
                        <div className="col-lg-9 col-md-6 col-sm-6 col-2">
                       
                      
                            <nav>      
                            
                                {getMenu()}
                            </nav>
                            <div className={"menu-btn" + (responsiveMenu ? " active " : "")} onClick={onClickHandler}>
                                <span className="bar1"></span>
                                <span className="bar2"></span>
                                <span className="bar3"></span>
                            </div> {/* <!--menu-btn end--> */}
                        </div>
                    </div>
                </div> {/* <!--header-content end--> */}
            </div>
        </header> {/* <!--header end--> */}


        <div className={"responsive-mobile-menu" + (responsiveMenu ? " active " : "")}>
        {getMenu()}
        </div>
    </>

}